export const parseTruthyString = (val = 'false') => val.toLowerCase() === 'true';
